// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralAssetCodeApprvService = {};

CollateralAssetCodeApprvService.getCollateralAssetCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/CollateralAsset/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CollateralAssetCodeApprvService;
